import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import { forceInputUppercase } from "../../utils/helper";
import DatePicker from "react-datepicker";
import moment from "moment";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import classnames from 'classnames';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import { Activity } from '../../components/activity';
import { fetchChangeLogs, createChangeLog, deleteChangeLog, getChangeLogs, updateChangeLog } from '../../actions/changeLog';

const $ = window.$;

const { SearchBar } = Search;
class ChangeLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user_role: "",
      loading: false,
      inputNotValid: false,
      version: "",
      releaseNote: "",
      videoLink: "",
      releaseDate: moment().toDate(),
      release_note_list: [],
      changeLogData: [],
      selectedChangeLogIdToDeleteID: "",
      loadingDeleteChangeLog: false,
      editReleaseDate:"",
    };
  }
handleChange = event => {
  if (event.target.name !== "videoLink") {
    forceInputUppercase(event);
  }
  const value = event.target.value;
  this.setState({
    ...this.state,
    [event.target.name]: value
   });
};

  urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  };

  submit(e) {
    e.preventDefault();
    this.setState({ loading: true });
    let data = {
      PetShopId: this.props.petShop.currentPetshop.id,
      release_date: this.state.releaseDate,
      version: this.state.version,
      video_link: this.state.videoLink,
      ChangeLogNotes: this.state.release_note_list
    };

    if(!(data.version && data.version.length > 0) || data.ChangeLogNotes.length <= 0){
      NotificationManager.warning("Incomplete information");
      this.setState({ loading: false, inputNotValid: true });
    }else if(data.video_link && !this.urlPatternValidation(data.video_link)){
      NotificationManager.warning("Inavlid video url");
      this.setState({ loading: false, inputNotValid: true });
    }else{
      this.props.createChangeLog(data);
    }

  }

  update(e) {
    e.preventDefault();
    this.setState({ loading: true });
    let data = {      
      PetShopId: this.props.petShop.currentPetshop.id,
      release_date : this.state.editReleaseDate,
      version : this.state.version,
      video_link: this.state.videoLink,
      ChangeLogNotes :this.state.release_note_list,
      id : this.state.editChangeLogId
    };   

    if(!(data.version && data.version.length > 0) || data.ChangeLogNotes.length <= 0){
      NotificationManager.warning("Incomplete information");
      this.setState({ loading: false, inputNotValid: true });
    }else if(data.video_link && !this.urlPatternValidation(data.video_link)){
      NotificationManager.warning("Inavlid video url");
      this.setState({ loading: false, inputNotValid: true });
    }else{
      this.props.updateChangeLog(data);
    }
  }

  resetState = () => {
    this.setState({
      loading: false,
      inputNotValid: false,
      version: "",
      releaseNote: "",
      releaseDate: moment().toDate(),
      release_note_list: [],
      videoLink: "",
    });
  };

  closeModal = () => {
    $("#add_change_log").modal("hide");
    $("#edit_change_log").modal("hide"); 
    this.resetState();
  };

  openAddChangeLogModal = () => {
    $("#add_change_log").modal("show");
  }

  componentWillReceiveProps = nextProps => {

    if (this.props.data.changeLogReducer.setChangeLog !== nextProps.data.changeLogReducer.setChangeLog) {
      this.props.fetchChangeLogs();
    }

    if(nextProps.setChangeLogError && this.props.setChangeLogError !== nextProps.setChangeLogError){
      if(nextProps.setChangeLogError.message && nextProps.setChangeLogError.message === 'Changelog version already exists'){
        NotificationManager.error("Changelog version already exists");
      }   
      else {
        NotificationManager.error("Failed to add changelog.");
      }  
      this.setState({loading : false});
    }

    if (this.props.data.changeLogReducer.changeLogs !== nextProps.data.changeLogReducer.changeLogs) {
      this.setState({ changeLogData: nextProps.data.changeLogReducer.changeLogs });
    }
    if (nextProps.changeLog && this.props.changeLog !== nextProps.changeLog) {
      this.resetState();
      NotificationManager.success("New Changelog added");
      $("#add_change_log").modal("hide");
    }
    if (this.props.data.changeLogReducer.selectedToDelete !== nextProps.data.changeLogReducer.selectedToDelete) {
      this.setState({ loadingDeleteChangeLog: false });
      NotificationManager.success("Changelog Deleted Successfully");
      this.props.fetchChangeLogs();
      $('#confirm_changelog_delete_modal').modal('hide');
    }
    if (nextProps.data.changeLogReducer.changeLog && this.props.data.changeLogReducer.changeLog !== nextProps.data.changeLogReducer.changeLog) {
      let log = nextProps.data.changeLogReducer.changeLog;   
      this.setState({
        release_note_list: log.ChangeLogNotes,
        version : log.version   ,
        editReleaseDate : new Date(log.release_date),   
        videoLink : log.video_link,     
       });          
      $('#edit_change_log').modal('show');
    }

    if (this.props.data.changeLogReducer.updateChangeLog !== nextProps.data.changeLogReducer.updateChangeLog) {
      this.setState({loading: false});
      NotificationManager.success("Changelog Updated Successfully");
      this.props.fetchChangeLogs(); 
      $('#edit_change_log').modal('hide');
      this.resetState()
    }

    if (this.props.data.changeLogReducer.updateChangeLogError !== nextProps.data.changeLogReducer.updateChangeLogError) {
      this.setState({loading: false});
      let errMessage = nextProps.data.changeLogReducer.updateChangeLogError ? nextProps.data.changeLogReducer.updateChangeLogError.message : "Cannot update"
      NotificationManager.error(errMessage);      
      $('#edit_change_log').modal('hide');
    }      

  };

  changeReleaseDate = value => {
    this.setState({ releaseDate: value });
  };

  changeDate = value => {
    this.setState({ editReleaseDate: value });
  };

  addToReleaseNotes = (note) => {
    if (note) {
      if (note.trim().length <= 250) {
        this.setState({
          release_note_list: [...this.state.release_note_list, { "text": note.trim() }],
          releaseNote: ""
        })
      }
      else {
        NotificationManager.warning("Maximum character length exceeded");
      }
    }
    else {
      NotificationManager.warning("Note cannot be empty");
    }
  }

  removeReleaseNote = (e, index) => {
    e.preventDefault();
    this.setState({
      release_note_list: this.state.release_note_list.filter((_, i) => i !== index)
    });
  }

  openConfirmModal(e, changeLogId) {
    e.preventDefault();
    this.setState({ selectedChangeLogIdToDeleteID: changeLogId });
    $("#confirm_changelog_delete_modal").modal("show");
  }

  openEditModel(e,id) {     
    e.preventDefault();
    this.setState({editChangeLogId:id});
    this.props.getChangeLogs(id)
  }

  deleteChangeLog() {
    this.setState({ loadingDeleteChangeLog: true });
    if (this.state.selectedChangeLogIdToDeleteID) { this.props.deleteChangeLog(this.state.selectedChangeLogIdToDeleteID); }
    else {
      NotificationManager.warning("Invalid changelog.");
      this.setState({ loadingDeleteChangeLog: false });
    }
  }

  tableColumnData = [
    {
      dataField: 'version', text: 'Version', sort: true, filter: textFilter()
    },
    {
      dataField: 'release_date', text: 'Released Date', formatter: cell => moment(cell).format('MM/DD/YYYY'), sort: true, filter: textFilter()
    },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('MM/DD/YYYY h:mm:ss a'), sort: true, filter: textFilter()
    },
    {
      dataField: 'createdBy', text: '', formatter: (cell, row) => {
        return ( 
          <Activity row={row} created={row.createdChangeLogVersion} updated={row.updatedChangeLogVersion} deleted={row.deletedChangeLogVersion}/>
        );
      }, sort: true,
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    },
    {
      dataField: "actions", text: "Actions", hidden: this.props.currentUser.UserPetstores[0].Role.role_name !== "Admin", formatter: (cell, row) => {
        return (
          <div>
             <button
              onClick={(e) => {          
                   this.openEditModel(e, row.id)
              }}
                className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
               >
                  <i className="far fa-edit"></i> 
              </button>

            <button
              onClick={(e) => {
                this.openConfirmModal(e, row.id)
              }}
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
            >
              <i className="la la-trash-o"></i>
            </button>
          </div>
        );
      }
    },
  ];

  expandRow = {
    renderer: row => (
      <>
        <p> Release Notes {row.video_link ? (<><strong> - [ </strong><a target="_blank" href={row.video_link}>DEMO <i className="fa fa-video"></i></a><strong> ] </strong></>): null} </p>
        <ul>
          {row.ChangeLogNotes.map((note, index) => (
            <li className="mb-0">{note.text}</li>
          ))}
        </ul>
      </>
    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: 'pointer' }}><i className="fas fa-chevron-circle-up"></i></b>;
      }
      return <b style={{ cursor: 'pointer' }}><i className="fas fa-chevron-circle-down"></i></b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <div style={{ cursor: 'pointer', marginTop: '0px' }}><i className="fas fa-chevron-circle-up"></i></div>
        );
      }
      return (
        <div style={{ cursor: 'pointer', marginTop: '0px' }}><i className="fas fa-chevron-circle-down"></i></div>
      );
    }
  };

  componentDidMount() {
    this.props.fetchChangeLogs();
  }

  render() {

    return (
      <div>
        {this.props.currentUser.UserPetstores[0].Role.role_name === "Admin" ? (
          <div className="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
            <div className="row align-items-center">
              <div className="col-xl-8 order-2 order-xl-1">
              </div>
              <div className="col-xl-4 order-1 order-xl-2 m--align-right">
                <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" data-toggle="modal" data-target="#add_change_log">
                  <span><i className="la la-plus"></i><span>New Changelog</span></span>
                </a>
                <div className="m-separator m-separator--dashed d-xl-none"></div>
              </div>
            </div>
          </div>) : (null)}
        {this.state.loading ?
          <div className="col-md-12" style={{ textAlign: 'center' }}>
            <Loader width="100px" height="100px;" />
          </div>
          :
          <ToolkitProvider
            keyField="id"
            data={this.state.changeLogData}
            columns={this.tableColumnData}
            search
            defaultSortDirection="asc"
            hover={true}
          >
            {
              props => (
                <div>
                  <div className='px-0 mb-4 search-bar'>
                    <div className='col-lg-3 px-0 inner-addon right-addon'>
                      <i className="fas fa-search"></i>
                      <SearchBar {...props.searchProps} />
                    </div>
                  </div>
                  <BootstrapTable
                    classes="petTable"
                    {...props.baseProps}
                    hover
                    striped
                    pagination={paginationFactory()}
                    expandRow={this.expandRow}
                  />
                </div>
              )
            }
          </ToolkitProvider>
        }

        <div
          className="modal fade show"
          id="add_change_log"
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <form className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Add New Changelog
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={this.closeModal}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="m-form__section m-form__section--first">
                        <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                            Version
                          </label>
                          <div className="col-xl-9 col-lg-9">
                            <input
                              type="text"
                              name="version"
                              value={this.state.version}
                              onChange={e => this.handleChange(e)}
                              className="form-control m-input"
                              placeholder=""
                            />
                            <span
                              className={
                                this.state.inputNotValid && this.state.version.length === 0
                                  ? "m-form__help_danger"
                                  : "m-form__help"
                              }
                            >
                              Please enter version
                            </span>
                          </div>
                        </div>

                        <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                            Release Date
                          </label>
                          <div className="col-xl-9 col-lg-9">
                            <DatePicker
                              selected={this.state.releaseDate}
                              value={this.state.releaseDate}
                              onChange={this.changeReleaseDate}
                              onSelect={this.changeReleaseDate}
                            />
                            <span
                              className={
                                this.state.inputNotValid && this.state.releaseDate.length === 0
                                  ? "m-form__help_danger"
                                  : "m-form__help"
                              }
                            >
                              Please enter released date
                            </span>
                          </div>
                        </div>
                        <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                            Video Link
                          </label>
                          <div className="col-xl-9 col-lg-9">
                            <textarea
                              rows="3"
                              name="videoLink"
                              value={this.state.videoLink}
                              onChange={e => this.handleChange(e)}
                              className="form-control m-input"
                              placeholder=""
                            />
                          </div>
                        </div>
                        <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                            Note
                          </label>
                          <div className="col-xl-9 col-lg-9">
                            <textarea
                              rows="3"
                              name="releaseNote"
                              value={this.state.releaseNote}
                              onChange={e => this.handleChange(e)}
                              className="form-control m-input"
                              placeholder=""
                            />                      
                            <div className="text-right">
                              <span className='complaint-word-count'>{this.state.releaseNote ? this.state.releaseNote.trim().length : 0}/250</span>
                            </div>
                            <button
                              style={{ float: "right" }}
                              type="button"
                              className="btn m-btn--square  btn-primary btn-sm mt-2"
                              onClick={e => this.addToReleaseNotes(this.state.releaseNote)}
                            >
                              Add to List
                            </button>
                          </div>
                        </div>

                        <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                            Notes
                          </label>
                        </div>
                        <div className="m-section__content">
                          <table className="table">
                            <thead>
                            </thead>
                            <tbody>
                              {this.state.release_note_list.map((note, index) => (
                                <tr>
                                  <td scope="row">{note.text}</td>
                                  <td scope="row"><button className="btn m-btn--pill btn-outline-danger btn-sm mx-2" style={{ float: "right" }} onClick={(e) => this.removeReleaseNote(e, index)}><span><i className="la la-minus-circle mr-2"></i></span></button></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>                    
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  {this.state.loading == false ? (
                    <div>
                      <button
                        type="button"
                        className="btn btn-secondary m-btn--pill mx-2"
                        onClick={this.closeModal}
                      >
                        Close
                      </button>
                      <button
                        onClick={(e) => this.submit(e)}
                        type="submit"
                        className="btn btn-primary m-btn--pill"
                      >
                        Submit
                      </button>
                    </div>
                  ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="confirm_changelog_delete_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to delete
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to delete this changelog ?
                </p>
              </div>
              <div className="modal-footer">
                {this.state.loadingDeleteChangeLog == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.deleteChangeLog()}
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>
                ) : (
                  <div className="center-row">
                    <Loader size={50} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
       
        <div
        className="modal fade show"
        id="edit_change_log"
        tabIndex="-1"
        role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <form className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                      Edit Changelog
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={this.closeModal}
                    aria-label="Close"
                  >
                      <span aria-hidden="true">×</span>
                  </button>
                </div>              
                <div className="modal-body">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="m-form__section m-form__section--first">
                      <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                              Version
                            </label>
                            <div className="col-xl-9 col-lg-9">
                            <input
                              type="text"
                              name="version"                         
                              value={this.state.version}
                              onChange={e => this.handleChange(e)}
                              className="form-control m-input"
                              placeholder=""
                            />
                            <span
                              className={
                                this.state.inputNotValid && this.state.version.length === 0
                                  ? "m-form__help_danger"
                                  : "m-form__help"
                              }
                            >
                              Please enter version 
                              </span>
                            </div>
                          </div>
                          <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                              Release Date
                            </label>
                            <div className="col-xl-9 col-lg-9">
                            <DatePicker
                              selected={this.state.editReleaseDate}
                              value={this.state.editReleaseDate}
                              onChange={this.changeDate}
                              onSelect={this.changeDate}
                            />
                              {/* <DatePicker 
                                  selected={this.state.editReleaseDate}
                                  value={this.state.editReleaseDate}
                                  onChange={this.changeDate}
                                  onSelect={this.changeDate}
                              /> */}
                            <span
                              className={
                                this.state.inputNotValid && this.state.editReleaseDate.length === 0
                                  ? "m-form__help_danger"
                                  : "m-form__help"
                              }
                            >
                              Please enter released date
                              </span>
                            </div>
                          </div> 
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">
                             Video Link
                            </label>
                            <div className="col-xl-9 col-lg-9">
                              <textarea
                                rows="3"
                                name="videoLink"
                                value={this.state.videoLink}
                                onChange={e => this.handleChange(e)}
                                className="form-control m-input"
                                placeholder=""
                              />                          
                            </div>
                          </div>  
                          <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                              Note
                            </label>
                            <div className="col-xl-9 col-lg-9">
                            <textarea
                              rows="3"                         
                              name="releaseNote"                         
                              value={this.state.releaseNote}
                              onChange={e => this.handleChange(e)}
                              className="form-control m-input"                          
                              placeholder=""
                            />
                              <div className="text-right">
                                <span className='complaint-word-count'>{this.state.releaseNote ? this.state.releaseNote.trim().length:0}/250</span>
                              </div>
                            <button
                                  style={{float:"right"}}
                                  type="button"
                                  className="btn m-btn--square  btn-primary btn-sm mt-2"
                                  onClick={e => this.addToReleaseNotes(this.state.releaseNote)}
                              >
                              Add to List
                            </button>
                            </div>
                          </div> 
                          <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                              Notes
                            </label>
                          </div>
                          <div className="m-section__content">
                  <table className="table">
                    <thead>
                    </thead>
                    <tbody>
                      {this.state.release_note_list.map((note , index) => (
                            <tr>
                                <td scope="row">{note.text}</td>
                                <td scope="row"><button className="btn m-btn--pill btn-outline-danger btn-sm mx-2" style={{float:"right"}} onClick={(e) => this.removeReleaseNote(e, index)}><span><i className="la la-minus-circle mr-2"></i></span></button></td>                                           
                            </tr>
                        ))} 
                    </tbody>
                  </table>
              </div>                  
                      </div>
                    </div>
                  </div>
                </div>   
                <div className="modal-footer">
              {this.state.loading == false ? (
                    <div>
                      <button
                        type="button"
                        className="btn btn-secondary m-btn--pill mx-2"
                        onClick={this.closeModal}
                      >
                        Close
                        </button>
                      <button
                        onClick={(e) => this.update(e)}
                        type="submit"
                        className="btn btn-primary m-btn--pill"
                      >
                        Update
                        </button>
                    </div>
                  ) : (
                      <div className="center-row">
                        <Loader size={50} />
                      </div>
                    )}
                </div>     
            </form>
           </div>
          </div>    
      </div> 

      </div>

    );
  }
}

  const mapStateToProps = state => ({
    petShop: state.petShopReducer,
    data: state,
    changeLog: state.changeLogReducer.setChangeLog,
    setChangeLogError : state.changeLogReducer.setChangeLogError,
    currentUser: state.userReducer.currentUser
  });

  const mapDispatchToProps = dispatch => ({
    fetchChangeLogs: () => {
      dispatch(fetchChangeLogs());
    },
    createChangeLog: (data) => {
      dispatch(createChangeLog(data));
    },
    deleteChangeLog: selected => {
      dispatch(deleteChangeLog(selected))
    },
    getChangeLogs : id => {
      dispatch(getChangeLogs(id))
    },
    updateChangeLog : (data) => {
      dispatch(updateChangeLog(data))
    },
  });

  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ChangeLog)
  );